// Delay after which new Shopify products should have their images setup
export const shopifyNewProductDelay = 3000
